var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkChain = function SvgLinkChain(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-chain 1",
    clipPath: "url(#clip0_1854_5050)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-chain--create-hyperlink-link-make-unlink-connection-chain"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2513",
    d: "M6.85742 3.42891L8.53057 1.75577C9.29247 1.01822 10.3137 0.609689 11.3741 0.618297C12.4345 0.626906 13.449 1.05196 14.1988 1.80179C14.9487 2.55161 15.3737 3.56612 15.3823 4.6265C15.3909 5.68688 14.9824 6.70815 14.2449 7.47005L12.5717 9.1432",
    stroke: "#262626",
    fill: "none",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2514",
    d: "M9.14222 12.5717L7.46908 14.2449C6.70718 14.9824 5.6859 15.3909 4.62552 15.3823C3.56514 15.3737 2.55064 14.9487 1.80081 14.1988C1.05099 13.449 0.62593 12.4345 0.617321 11.3741C0.608712 10.3137 1.01724 9.29247 1.75479 8.53057L3.42794 6.85742",
    stroke: "#262626",
    fill: "none",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2515",
    d: "M10.2843 5.71484L5.71289 10.2863",
    stroke: "#262626",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1854_5050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkChain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "link-chain.6b39bbf3f863da4a860826e62e7b266b.svg";